import React from 'react'
import PropTypes from 'prop-types'

import { Wrapper } from 'Components/UI'

import map from 'lodash/map'

import Feature from './feature'
import { Container, Content } from './styles'

function Features({ data }) {
  return (
    <Container>
      <Wrapper alignItems="flex-start" flexDirection="column">
        <Content>
          {map(data, (headline, index) => (
            <Feature data={headline} index={index} key={headline?.id} />
          ))}
        </Content>
      </Wrapper>
    </Container>
  )
}

Features.defaultProps = {
  data: [],
}

Features.propTypes = {
  data: PropTypes.array,
}

export default Features
